import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Address from './address';
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom';


const Formdiv = styled.div`
padding: 5%;
margin: 3% auto;
`;

const Phone = ({ value, onChange }) => (
  <div>
    <PhoneInput
      id="phonenumber"
      name="phonenumber"
      defaultCountry='IN'
      placeholder="Enter phone number"
      value={value}
      onChange={onChange}
    />
    {value && isValidPhoneNumber(value) ? <span>&#9989;</span> : ""}
  </div>
);

const Form = () => {
  const history = useNavigate();
  const form = useRef();
  const [phone, setPhone] = useState('');

  const PostData = async (e) => {
    e.preventDefault();

    // validate form fields
    const user = {
      firstname: form.current.firstname.value,
      lastname: form.current.lastname.value,
      email: form.current.email.value,
      phonenumber: phone,
      contactMessage: form.current.contactMessage.value
    };
    if (!user.firstname || !user.lastname || !user.email || !user.phonenumber || !user.contactMessage) {
      alert('Please fill all fields');
      return;
    }
    if (!isValidPhoneNumber(user.phonenumber)) {
      alert('Please enter a valid phone number');
      return;
    }
    if (!user.email.includes('@') || !user.email.includes('.') || user.email.indexOf('@') > user.email.lastIndexOf('.') || user.email.indexOf('@') === 0 || user.email.lastIndexOf('.') === user.email.length - 1) {
      alert('Please enter a valid email address');
      return;
    }

    emailjs.sendForm(
      'service_vhnbv4c',
      'template_w346ced',
      form.current,
      'wBNtg1Wuyv_Yrtsbx'
    )
      .then((result) => {
        alert('Message sent!');
        history.push("/contact");
      }, (error) => {
        alert('Failed to send message, please try again.');
      });
  }

  return (
    <Formdiv className='shadow-lg'>
      <form ref={form} method="post" className="contact">
        <h1 className="h3 mb-3 fw-normal">Contact Us</h1>
        <div className="form-floating">
          <input type="text" className="form-control" id="firstname" name="firstname" autoComplete="off" placeholder="First name" />
          <label htmlFor="firstname">First Name</label>
        </div>
        <div className="form-floating mt-4">
          <input type="text" className="form-control" id="lastname" name="lastname" autoComplete="off" placeholder="Last name" />
          <label htmlFor="lastname">Last Name</label>
        </div>
        <div className="form-floating mt-4">
          <input type="email" className="form-control" id="email" name="email" autoComplete="off" placeholder="Email" required />
          <label htmlFor="floatingEmail" required>Email</label>
        </div>
        <div className='mt-4'>
          <Phone value={phone} onChange={setPhone} />
          {/* Hidden input to include phone in form data */}
          <input type="hidden" name="phonenumber" value={phone || ''} />
        </div>
        <div className='mt-3'>
          <label style={{ display: "block" }} htmlFor="contactMessage">Message:</label>
          <textarea id="contactMessage" name="contactMessage" rows="4" cols="50"></textarea>
        </div>
        <button className="w-100 btn btn-lg btn-primary mt-4" type="submit" onClick={PostData}>Send</button>
      </form>
    </Formdiv>
  );
}

const AppContact = () => {
  return (
    <div>
      <Address />
      <div style={{ display: "flex" }}>
        <Form />
      </div>
    </div>
  );
}

export default AppContact;